import styled, { css } from 'styled-components'

import { FemiColor } from './constants'

export const FemiTitle = styled.h2<{ isAlignedLeft?: boolean }>`
  color: ${FemiColor.BLACK};
  font-family: 'Lora', serif;
  font-size: 28px;
  font-weight: 600;
  line-height: 36px;
  text-align: ${({ isAlignedLeft }) => (isAlignedLeft ? 'start' : 'center')};
`

export const FemiDescription = styled.p`
  color: ${FemiColor.GRAY};
  font-family: 'Open Sans', sans-serif;
  font-size: 17px;
  font-weight: 400;
  line-height: 24px;
  text-align: center;
`

export const FemiContent = styled.div`
  max-width: 390px;
  margin: 0 auto;
  padding: 24px 16px 0;
`

export const FemiOptions = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`

export const FemiBottomArea = styled.div<{ isFixed?: boolean }>`
  width: 100%;
  max-width: 390px;
  margin: 0 auto;
  padding: 16px;

  ${({ isFixed }) =>
    isFixed &&
    css`
      position: fixed;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
      background: linear-gradient(
        180deg,
        rgba(255, 255, 255, 0) 0%,
        ${FemiColor.WHITE} 40%
      );
    `}
`

export const FemiOutcomeTitle = styled(FemiTitle)`
  margin-bottom: 48px;
`
